<template>
  <chart title="Active Users" @filtersChanged="update" :apiData="all" />
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Chart from '@/components/Chart'

export default {
  name: 'UsersActiveAll',
  components: {
    Chart,
  },
  computed: {
    ...mapState('users/active', ['all']),
  },
  methods: {
    ...mapActions('users/active', ['getAll']),
    update({ startDate, endDate }) {
      this.getAll({ startDate, endDate })
    },
  },
}
</script>
